<template>
    <div class="twelve-month-donut">
        <div class="donut">
            <DonutChart :dataset="categories" :radius="160" :hole="136">
                <template #default="{ height }">
                    <g text-anchor="middle" fill="black" :font-size="height / 10" font-family="Lato">
                        <text>
                            <tspan dx="0" dy="-0.5em">Total:</tspan>
                        </text>
                        <text>
                            <tspan dy="1em">{{ totalDisplay }}</tspan>
                        </text>
                    </g>
                </template>
            </DonutChart>
            <div class="total" style="display: none">
                Total:<br />
                {{ totalDisplay }}
            </div>
        </div>
        <ChartKey :values="categories" :showValues="showValues" />
    </div>
</template>

<script>
import ChartKey from '@/pages/ExecutivePage/CompensationTab/ChartKey.vue'
import DonutChart from '@/components/charts/DonutChart.vue'
import { compensationFormats } from '@/utils/format'

export default {
    components: { DonutChart, ChartKey },
    props: {
        categories: {
            type: Array,
            required: true,
        },
        currency: {
            type: String,
        },
        showValues: {
            type: Boolean,
            default: false,
        },
        total: {
            type: Number,
            required: true,
        },
    },

    computed: {
        totalDisplay() {
            return compensationFormats.currency(this.total, { currency: this.currency ?? 'USD' })
        },
    },
}
</script>
